export default "__VITE_ASSET__BhlRC8pO__"